import React from "react";
import { Button } from "ui/components/button";
import ChatAttachmentInput from "components/file-upload/chat-input";
import EmployeeMention from "./employee-mention";

export default function ActivityEditor({ onSubmit, disabled }) {
  const [message, setMessage] = React.useState("");
  const [attachment, setAttachment] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [mentionMap, setMentionMap] = React.useState({}); // { label: id }
  const [resetKey, setResetKey] = React.useState(0);

  function handleMentionSelect({ id, label }) {
    setMentionMap((prev) => ({ ...prev, [label]: id }));
  }

  function handleMentionsChange(labels) {
    setMentionMap((prev) => {
      const next = {};
      labels?.forEach?.((label) => {
        if (prev[label]) next[label] = prev[label];
      });
      return next;
    });
  }

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  async function handleSubmit(e) {
    e?.preventDefault?.();
    if (!message.trim() && !attachment) return;
    setIsSubmitting(true);
    try {
      let transformed = message;

      for (const [label, id] of Object.entries(mentionMap)) {
        if (!label || !id) continue;
        const pattern = new RegExp(
          `@${escapeRegExp(label)}(?![A-Za-z0-9_])`,
          "g"
        );
        transformed = transformed.replace(pattern, ` @${id} `);
      }

      await onSubmit({ message: transformed, attachment });
      setMessage("");
      setAttachment(null);
      setMentionMap({});
      setResetKey((k) => k + 1); // remount input to clear internal mention state
    } finally {
      setIsSubmitting(false);
    }
  }

  const isDisabled = disabled || isSubmitting;
  const canSend = !!message.trim() && !isDisabled;

  return (
    <form className="space-y-3" onSubmit={handleSubmit}>
      <EmployeeMention
        key={resetKey}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write a message... (use @username to mention someone)"
        disabled={isDisabled}
        className="min-h-32 w-full"
        onMentionSelect={handleMentionSelect}
        onMentionsChange={handleMentionsChange}
      />
      <div className="flex justify-end gap-2">
        <Button type="submit" disabled={!canSend}>
          {isSubmitting ? "Sending..." : "Send"}
        </Button>
        <ChatAttachmentInput
          value={attachment}
          onChange={setAttachment}
          disabled={isDisabled}
        />
      </div>
    </form>
  );
}
